import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function StarFill({ color = 'icon.primary', ...props }) {
  return (
    <IconBase viewBox="0 0 17 17" {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.49773 14.627L12.5779 16.8651C13.3726 17.3014 14.3013 16.5972
         14.1492 15.6726L13.3704 10.9283L16.6718 7.57103C17.3143 6.91665
          16.9601 5.77622 16.0723 5.64108L11.5108 4.94876L9.4718 0.631265C9.07445
           -0.210422 7.92782 -0.210422 7.53047 0.631265L5.4915 4.94876L0.927673
            5.64345C0.0398824 5.77859 -0.314325 6.91902 0.328244 7.5734L3.62964
             10.9307L2.85084 15.6749C2.69871 16.5996 3.62737 17.3038 4.42207
              16.8675L8.50227 14.6293H8.49773V14.627Z"
        fill={color}
      />
    </IconBase>
  )
}

StarFill.propTypes = {
  color: PropTypes.string,
}

export default StarFill
